import { useState } from 'react';

interface InstagramFeedProps {
  selectedCategory: string;
}

interface InstagramAccount {
  id: string;
  username: string;
  shopName: string;
  category: string;
  location: string;
  businessType: string;
  followers: number;
  posts: {
    id: string;
    image: string;
    caption: string;
    likes: number;
    timestamp: string;
  }[];
}

export default function InstagramFeed({ selectedCategory }: InstagramFeedProps) {
  const [currentSlides, setCurrentSlides] = useState<Record<string, number>>({});

  const accounts: InstagramAccount[] = [
    {
      id: 'daum_nail',
      username: '@daum_nail_salon',
      shopName: '다움네일살롱',
      category: '네일',
      location: '강남구 신사동',
      businessType: '네일아트 전문샵',
      followers: 12500,
      posts: [
        {
          id: '1',
          image: 'https://public.readdy.ai/ai/img_res/41b2b1d7962e3839baea40b0b1b35a1e.jpg',
          caption: '클래식 프렌치 네일 💅 심플하지만 우아한 디자인',
          likes: 1243,
          timestamp: '2시간 전'
        },
        {
          id: '2',
          image: 'https://readdy.ai/api/search-image?query=Trendy%20gel%20nail%20art%20with%20pastel%20pink%20and%20lavender%20colors%2C%20modern%20floral%20design%20decoration%2C%20professional%20manicure%20work%20on%20natural%20nails%2C%20soft%20feminine%20aesthetic%2C%20luxury%20beauty%20content%2C%20elegant%20sophisticated%20style%20with%20simple%20white%20background&width=600&height=600&seq=port-nail-2&orientation=squarish',
          caption: '봄 시즌 플라워 네일 🌷 너무 예뻐요',
          likes: 1567,
          timestamp: '5시간 전'
        },
        {
          id: '3',
          image: 'https://readdy.ai/api/search-image?query=Artistic%20minimalist%20nail%20design%20with%20geometric%20patterns%20and%20lines%2C%20modern%20nail%20art%20with%20pastel%20pink%20and%20beige%20colors%2C%20professional%20manicure%20photography%2C%20elegant%20beauty%20content%2C%20sophisticated%20feminine%20style%2C%20premium%20quality%20work%20with%20simple%20white%20background&width=600&height=600&seq=port-nail-3&orientation=squarish',
          caption: '미니멀 라인 네일 디자인 💫',
          likes: 1092,
          timestamp: '8시간 전'
        },
        {
          id: '4',
          image: 'https://readdy.ai/api/search-image?query=Glamorous%20glitter%20nail%20art%20with%20rose%20gold%20shimmer%20and%20sparkles%2C%20festive%20party%20nail%20design%2C%20professional%20manicure%20work%2C%20elegant%20feminine%20aesthetic%2C%20luxury%20beauty%20content%2C%20sophisticated%20style%20with%20simple%20white%20background&width=600&height=600&seq=port-nail-4&orientation=squarish',
          caption: '글리터 네일로 화려하게 ✨',
          likes: 1834,
          timestamp: '12시간 전'
        },
        {
          id: '5',
          image: 'https://readdy.ai/api/search-image?query=Cute%20character%20nail%20art%20design%20with%20pastel%20colors%2C%20playful%20kawaii%20style%20manicure%2C%20professional%20nail%20work%2C%20soft%20feminine%20aesthetic%2C%20modern%20beauty%20content%2C%20elegant%20sophisticated%20look%20with%20simple%20white%20background&width=600&height=600&seq=port-nail-5&orientation=squarish',
          caption: '귀여운 캐릭터 네일 🐰',
          likes: 2103,
          timestamp: '1일 전'
        }
      ]
    },
    {
      id: 'lavender_lash',
      username: '@lavender_eyelash',
      shopName: '라벤더 아이래쉬',
      category: '속눈썹',
      location: '서초구 반포동',
      businessType: '속눈썹 연장 전문',
      followers: 8900,
      posts: [
        {
          id: '1',
          image: 'https://readdy.ai/api/search-image?query=Natural%20volume%20eyelash%20extensions%20close-up%20on%20beautiful%20eye%2C%20professional%20lash%20work%20with%20soft%20feminine%20beauty%2C%20elegant%20makeup%20photography%2C%20premium%20beauty%20service%20result%2C%20clean%20aesthetic%20with%20soft%20pink%20tones%20and%20simple%20background&width=600&height=600&seq=port-lash-1&orientation=squarish',
          caption: '자연스러운 속눈썹 연장 ✨ 매일 아침이 편해져요',
          likes: 892,
          timestamp: '3시간 전'
        },
        {
          id: '2',
          image: 'https://readdy.ai/api/search-image?query=Dramatic%20volume%20lash%20extensions%20with%20cat%20eye%20effect%2C%20professional%20eyelash%20work%20close-up%2C%20glamorous%20beauty%20photography%2C%20elegant%20feminine%20style%2C%20luxury%20service%20result%2C%20sophisticated%20aesthetic%20with%20simple%20background&width=600&height=600&seq=port-lash-2&orientation=squarish',
          caption: '볼륨 래쉬로 눈매 교정 효과 💕',
          likes: 1234,
          timestamp: '7시간 전'
        },
        {
          id: '3',
          image: 'https://readdy.ai/api/search-image?query=Mega%20volume%20eyelash%20extensions%20with%20fluffy%20texture%2C%20professional%20lash%20artistry%20close-up%2C%20beautiful%20eye%20with%20dramatic%20lashes%2C%20elegant%20beauty%20photography%2C%20premium%20service%20result%20with%20simple%20background&width=600&height=600&seq=port-lash-3&orientation=squarish',
          caption: '메가볼륨 래쉬 🌟 풍성함의 끝',
          likes: 1456,
          timestamp: '10시간 전'
        },
        {
          id: '4',
          image: 'https://readdy.ai/api/search-image?query=Colored%20eyelash%20extensions%20with%20brown%20and%20burgundy%20tones%2C%20artistic%20lash%20work%20close-up%2C%20soft%20feminine%20beauty%20photography%2C%20elegant%20makeup%20result%2C%20sophisticated%20aesthetic%20with%20simple%20background&width=600&height=600&seq=port-lash-4&orientation=squarish',
          caption: '컬러 래쉬로 분위기 체인지 🎨',
          likes: 967,
          timestamp: '15시간 전'
        },
        {
          id: '5',
          image: 'https://readdy.ai/api/search-image?query=Hybrid%20eyelash%20extensions%20combining%20classic%20and%20volume%2C%20professional%20lash%20work%20close-up%20on%20beautiful%20eye%2C%20natural%20elegant%20beauty%20photography%2C%20premium%20service%20result%20with%20simple%20background&width=600&height=600&seq=port-lash-5&orientation=squarish',
          caption: '하이브리드 래쉬 추천해요 💫',
          likes: 1123,
          timestamp: '1일 전'
        }
      ]
    },
    {
      id: 'petal_hair',
      username: '@petal_hair_salon',
      shopName: '페탈 헤어살롱',
      category: '헤어',
      location: '마포구 홍대입구',
      businessType: '헤어 컬러 & 스타일링',
      followers: 15200,
      posts: [
        {
          id: '1',
          image: 'https://readdy.ai/api/search-image?query=Beautiful%20rose%20gold%20balayage%20hair%20color%20transformation%2C%20soft%20pink%20and%20gold%20tones%20on%20long%20hair%2C%20professional%20hair%20styling%20photography%2C%20elegant%20feminine%20hairstyle%2C%20luxury%20salon%20work%2C%20modern%20beauty%20aesthetic%20with%20simple%20background&width=600&height=600&seq=port-hair-1&orientation=squarish',
          caption: '로즈골드 발레아쥬 염색 ✨ 완전 만족',
          likes: 1834,
          timestamp: '4시간 전'
        },
        {
          id: '2',
          image: 'https://readdy.ai/api/search-image?query=Trendy%20ash%20gray%20hair%20color%20with%20silver%20tones%2C%20modern%20hair%20transformation%20on%20medium%20length%20hair%2C%20professional%20salon%20photography%2C%20elegant%20feminine%20style%2C%20luxury%20beauty%20work%20with%20simple%20background&width=600&height=600&seq=port-hair-2&orientation=squarish',
          caption: '애쉬 그레이 염색 🌫️ 시크한 매력',
          likes: 2103,
          timestamp: '6시간 전'
        },
        {
          id: '3',
          image: 'https://readdy.ai/api/search-image?query=Elegant%20wavy%20perm%20hairstyle%20with%20soft%20curls%2C%20professional%20hair%20styling%20on%20long%20hair%2C%20feminine%20beauty%20photography%2C%20luxury%20salon%20work%2C%20sophisticated%20aesthetic%20with%20simple%20background&width=600&height=600&seq=port-hair-3&orientation=squarish',
          caption: '웨이브 펌으로 여신 헤어 완성 💕',
          likes: 1567,
          timestamp: '9시간 전'
        },
        {
          id: '4',
          image: 'https://readdy.ai/api/search-image?query=Stylish%20bob%20haircut%20with%20blunt%20cut%2C%20modern%20short%20hairstyle%20transformation%2C%20professional%20salon%20photography%2C%20elegant%20feminine%20look%2C%20clean%20aesthetic%20with%20simple%20background&width=600&height=600&seq=port-hair-4&orientation=squarish',
          caption: '단발 커트로 이미지 변신 ✂️',
          likes: 1892,
          timestamp: '14시간 전'
        },
        {
          id: '5',
          image: 'https://readdy.ai/api/search-image?query=Beautiful%20ombre%20hair%20color%20from%20dark%20to%20light%20pink%2C%20gradient%20hair%20transformation%20on%20long%20hair%2C%20professional%20salon%20photography%2C%20elegant%20feminine%20style%2C%20luxury%20beauty%20work%20with%20simple%20background&width=600&height=600&seq=port-hair-5&orientation=squarish',
          caption: '옴브레 염색 그라데이션 🎨',
          likes: 2234,
          timestamp: '1일 전'
        }
      ]
    },
    {
      id: 'aurora_makeup',
      username: '@aurora_makeup_studio',
      shopName: '오로라 메이크업',
      category: '메이크업',
      location: '송파구 잠실동',
      businessType: '웨딩 & 파티 메이크업',
      followers: 18700,
      posts: [
        {
          id: '1',
          image: 'https://readdy.ai/api/search-image?query=Beautiful%20bridal%20wedding%20makeup%20with%20soft%20pink%20tones%20and%20glowing%20skin%2C%20elegant%20romantic%20beauty%20look%2C%20professional%20makeup%20artistry%20photography%2C%20sophisticated%20feminine%20style%2C%20luxury%20beauty%20work%20with%20simple%20background&width=600&height=600&seq=port-makeup-1&orientation=squarish',
          caption: '웨딩 메이크업 💕 특별한 날을 더 빛나게',
          likes: 3421,
          timestamp: '2시간 전'
        },
        {
          id: '2',
          image: 'https://readdy.ai/api/search-image?query=Glamorous%20evening%20party%20makeup%20with%20rose%20gold%20shimmer%20and%20dramatic%20eyes%2C%20elegant%20beauty%20look%2C%20professional%20makeup%20artistry%20photography%2C%20sophisticated%20feminine%20style%2C%20luxury%20cosmetics%20with%20simple%20background&width=600&height=600&seq=port-makeup-2&orientation=squarish',
          caption: '파티 메이크업 🎉 화려하게 변신',
          likes: 2234,
          timestamp: '5시간 전'
        },
        {
          id: '3',
          image: 'https://readdy.ai/api/search-image?query=Natural%20daily%20makeup%20look%20with%20soft%20pink%20tones%20and%20dewy%20skin%2C%20elegant%20feminine%20beauty%2C%20professional%20makeup%20photography%2C%20clean%20aesthetic%2C%20sophisticated%20style%20with%20simple%20background&width=600&height=600&seq=port-makeup-3&orientation=squarish',
          caption: '데일리 메이크업 ✨ 자연스럽게',
          likes: 1876,
          timestamp: '8시간 전'
        },
        {
          id: '4',
          image: 'https://readdy.ai/api/search-image?query=Trendy%20coral%20makeup%20look%20with%20peachy%20tones%20and%20fresh%20glow%2C%20modern%20beauty%20photography%2C%20elegant%20feminine%20style%2C%20professional%20makeup%20artistry%20with%20simple%20background&width=600&height=600&seq=port-makeup-4&orientation=squarish',
          caption: '코랄 메이크업 🍑 생기있게',
          likes: 2567,
          timestamp: '12시간 전'
        },
        {
          id: '5',
          image: 'https://readdy.ai/api/search-image?query=Elegant%20smokey%20eye%20makeup%20with%20burgundy%20and%20brown%20tones%2C%20dramatic%20beauty%20look%2C%20professional%20makeup%20artistry%20photography%2C%20sophisticated%20feminine%20style%20with%20simple%20background&width=600&height=600&seq=port-makeup-5&orientation=squarish',
          caption: '스모키 메이크업 🌙 섹시한 분위기',
          likes: 2890,
          timestamp: '1일 전'
        }
      ]
    },
    {
      id: 'rose_skincare',
      username: '@rose_skincare_clinic',
      shopName: '로즈 스킨케어',
      category: '피부관리',
      location: '강남구 청담동',
      businessType: '피부관리 & 에스테틱',
      followers: 11300,
      posts: [
        {
          id: '1',
          image: 'https://readdy.ai/api/search-image?query=Glowing%20healthy%20radiant%20skin%20after%20professional%20facial%20treatment%2C%20beautiful%20complexion%20with%20dewy%20finish%2C%20skincare%20result%20photography%2C%20soft%20pink%20tones%2C%20beauty%20wellness%20aesthetic%2C%20premium%20spa%20service%20with%20simple%20background&width=600&height=600&seq=port-skin-1&orientation=squarish',
          caption: '피부관리 후 촉촉한 광채 피부 🌸',
          likes: 2156,
          timestamp: '3시간 전'
        },
        {
          id: '2',
          image: 'https://readdy.ai/api/search-image?query=Relaxing%20spa%20facial%20treatment%20with%20soft%20pink%20towels%20and%20beauty%20products%2C%20serene%20wellness%20environment%20setup%2C%20professional%20skincare%20atmosphere%2C%20elegant%20feminine%20aesthetic%2C%20luxury%20beauty%20service%20with%20simple%20background&width=600&height=600&seq=port-skin-2&orientation=squarish',
          caption: '힐링 타임 🧖‍♀️ 나를 위한 시간',
          likes: 967,
          timestamp: '6시간 전'
        },
        {
          id: '3',
          image: 'https://readdy.ai/api/search-image?query=Professional%20facial%20massage%20technique%20demonstration%2C%20skincare%20treatment%20hands%20on%20face%2C%20elegant%20beauty%20service%20photography%2C%20soft%20feminine%20aesthetic%2C%20premium%20spa%20work%20with%20simple%20background&width=600&height=600&seq=port-skin-3&orientation=squarish',
          caption: '페이셜 마사지로 리프팅 효과 💆‍♀️',
          likes: 1432,
          timestamp: '10시간 전'
        },
        {
          id: '4',
          image: 'https://readdy.ai/api/search-image?query=Luxury%20skincare%20products%20arrangement%20with%20pink%20and%20white%20bottles%2C%20elegant%20beauty%20product%20photography%2C%20premium%20cosmetics%20display%2C%20sophisticated%20feminine%20aesthetic%20with%20simple%20background&width=600&height=600&seq=port-skin-4&orientation=squarish',
          caption: '프리미엄 스킨케어 제품 라인 ✨',
          likes: 1789,
          timestamp: '15시간 전'
        },
        {
          id: '5',
          image: 'https://readdy.ai/api/search-image?query=Clear%20smooth%20skin%20texture%20close-up%20after%20treatment%2C%20healthy%20glowing%20complexion%2C%20professional%20skincare%20result%20photography%2C%20elegant%20beauty%20aesthetic%20with%20simple%20background&width=600&height=600&seq=port-skin-5&orientation=squarish',
          caption: '맑고 투명한 피부 결 🌟',
          likes: 2345,
          timestamp: '1일 전'
        }
      ]
    },
    {
      id: 'silk_waxing',
      username: '@silk_waxing_studio',
      shopName: '실크 왁싱스튜디오',
      category: '왁싱',
      location: '용산구 이태원동',
      businessType: '전신 왁싱 전문',
      followers: 6800,
      posts: [
        {
          id: '1',
          image: 'https://readdy.ai/api/search-image?query=Clean%20smooth%20skin%20after%20professional%20waxing%20treatment%2C%20silky%20soft%20legs%20result%2C%20beauty%20service%20photography%2C%20elegant%20feminine%20aesthetic%2C%20premium%20quality%20work%20with%20soft%20pink%20tones%20and%20simple%20background&width=600&height=600&seq=port-wax-1&orientation=squarish',
          caption: '매끈한 피부 완성 ✨ 왁싱 후 만족도 100%',
          likes: 734,
          timestamp: '4시간 전'
        },
        {
          id: '2',
          image: 'https://readdy.ai/api/search-image?query=Professional%20waxing%20studio%20interior%20with%20clean%20aesthetic%2C%20modern%20beauty%20salon%20environment%2C%20elegant%20feminine%20decor%20with%20soft%20pink%20and%20white%20colors%2C%20luxury%20service%20space%20with%20simple%20background&width=600&height=600&seq=port-wax-2&orientation=squarish',
          caption: '깨끗하고 편안한 왁싱 공간 🌸',
          likes: 892,
          timestamp: '8시간 전'
        },
        {
          id: '3',
          image: 'https://readdy.ai/api/search-image?query=Natural%20waxing%20products%20and%20tools%20arrangement%2C%20professional%20beauty%20service%20supplies%2C%20elegant%20product%20photography%20with%20soft%20pink%20tones%2C%20clean%20aesthetic%20with%20simple%20background&width=600&height=600&seq=port-wax-3&orientation=squarish',
          caption: '천연 성분 왁싱 제품 사용 🍃',
          likes: 567,
          timestamp: '12시간 전'
        },
        {
          id: '4',
          image: 'https://readdy.ai/api/search-image?query=Smooth%20silky%20skin%20texture%20close-up%20after%20waxing%2C%20healthy%20glowing%20complexion%2C%20professional%20beauty%20result%20photography%2C%20elegant%20feminine%20aesthetic%20with%20simple%20background&width=600&height=600&seq=port-wax-4&orientation=squarish',
          caption: '부드러운 피부 결 💕',
          likes: 1023,
          timestamp: '16시간 전'
        },
        {
          id: '5',
          image: 'https://readdy.ai/api/search-image?query=Professional%20waxing%20aftercare%20products%20with%20soothing%20cream%20and%20lotion%2C%20elegant%20beauty%20product%20photography%2C%20soft%20pink%20and%20white%20aesthetic%2C%20premium%20skincare%20with%20simple%20background&width=600&height=600&seq=port-wax-5&orientation=squarish',
          caption: '왁싱 후 진정 케어 제품 추천 🌿',
          likes: 845,
          timestamp: '1일 전'
        }
      ]
    }
  ];

  const filteredAccounts = selectedCategory === '전체' 
    ? accounts 
    : accounts.filter(account => account.category === selectedCategory);

  const handlePrevSlide = (accountId: string, totalPosts: number) => {
    setCurrentSlides(prev => ({
      ...prev,
      [accountId]: ((prev[accountId] || 0) - 1 + totalPosts) % totalPosts
    }));
  };

  const handleNextSlide = (accountId: string, totalPosts: number) => {
    setCurrentSlides(prev => ({
      ...prev,
      [accountId]: ((prev[accountId] || 0) + 1) % totalPosts
    }));
  };

  return (
    <div className="space-y-8">
      {filteredAccounts.map((account) => {
        const currentSlide = currentSlides[account.id] || 0;
        const currentPost = account.posts[currentSlide];

        return (
          <div key={account.id} className="bg-white rounded-2xl shadow-sm border border-gray-100 overflow-hidden hover:shadow-lg transition-shadow">
            {/* Main Content - Image Left, Info Right */}
            <div className="flex flex-col lg:flex-row">
              {/* Image Carousel - Left Side */}
              <div className="relative lg:w-2/5">
                <div className="relative w-full h-96 bg-gray-50">
                  <img
                    src={currentPost.image}
                    alt={currentPost.caption}
                    className="w-full h-full object-cover object-top"
                  />
                  
                  {/* Navigation Arrows */}
                  {account.posts.length > 1 && (
                    <>
                      <button
                        onClick={() => handlePrevSlide(account.id, account.posts.length)}
                        className="absolute left-4 top-1/2 -translate-y-1/2 w-10 h-10 flex items-center justify-center bg-white/90 backdrop-blur-sm rounded-full shadow-lg hover:bg-white transition-all cursor-pointer"
                      >
                        <i className="ri-arrow-left-s-line text-xl text-gray-800"></i>
                      </button>
                      <button
                        onClick={() => handleNextSlide(account.id, account.posts.length)}
                        className="absolute right-4 top-1/2 -translate-y-1/2 w-10 h-10 flex items-center justify-center bg-white/90 backdrop-blur-sm rounded-full shadow-lg hover:bg-white transition-all cursor-pointer"
                      >
                        <i className="ri-arrow-right-s-line text-xl text-gray-800"></i>
                      </button>
                    </>
                  )}

                  {/* Slide Indicators */}
                  <div className="absolute bottom-4 left-1/2 -translate-x-1/2 flex items-center space-x-2">
                    {account.posts.map((_, index) => (
                      <button
                        key={index}
                        onClick={() => setCurrentSlides(prev => ({ ...prev, [account.id]: index }))}
                        className={`w-2 h-2 rounded-full transition-all cursor-pointer ${
                          index === currentSlide 
                            ? 'bg-white w-6' 
                            : 'bg-white/50 hover:bg-white/75'
                        }`}
                      />
                    ))}
                  </div>
                </div>
              </div>

              {/* Shop Info & Post Details - Right Side */}
              <div className="lg:w-3/5 flex flex-col">
                {/* Account Header */}
                <div className="p-8 border-b border-gray-100">
                  <div className="flex items-start justify-between mb-6">
                    <div className="flex items-center space-x-4">
                      <div className="w-20 h-20 flex items-center justify-center bg-gradient-to-br from-rose-400 to-pink-400 rounded-full">
                        <i className="ri-instagram-line text-white text-3xl"></i>
                      </div>
                      <div>
                        <h3 className="text-2xl font-bold text-gray-800 mb-2">{account.shopName}</h3>
                        <p className="text-base text-gray-500 mb-3">{account.username}</p>
                      </div>
                    </div>
                    <div className="inline-flex items-center space-x-2 px-4 py-2 bg-rose-50 text-rose-400 text-sm font-medium rounded-full">
                      <i className="ri-user-follow-line text-lg"></i>
                      <span>{account.followers.toLocaleString()}</span>
                    </div>
                  </div>

                  {/* Location & Business Type - Large Display */}
                  <div className="space-y-4">
                    <div className="flex items-center space-x-3 p-4 bg-gradient-to-r from-rose-50 to-pink-50 rounded-xl">
                      <div className="w-12 h-12 flex items-center justify-center bg-white rounded-lg shadow-sm">
                        <i className="ri-map-pin-line text-2xl text-rose-400"></i>
                      </div>
                      <div>
                        <p className="text-xs text-gray-500 mb-1">위치</p>
                        <p className="text-lg font-semibold text-gray-800">{account.location}</p>
                      </div>
                    </div>

                    <div className="flex items-center space-x-3 p-4 bg-gradient-to-r from-purple-50 to-pink-50 rounded-xl">
                      <div className="w-12 h-12 flex items-center justify-center bg-white rounded-lg shadow-sm">
                        <i className="ri-store-2-line text-2xl text-purple-400"></i>
                      </div>
                      <div>
                        <p className="text-xs text-gray-500 mb-1">업종</p>
                        <p className="text-lg font-semibold text-gray-800">{account.businessType}</p>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Post Info */}
                <div className="p-8 flex-1">
                  <div className="flex items-center justify-between mb-4">
                    <div className="flex items-center space-x-6">
                      <button className="flex items-center space-x-2 text-rose-400 hover:text-rose-500 transition-colors cursor-pointer">
                        <i className="ri-heart-fill text-2xl"></i>
                        <span className="text-base font-medium">{currentPost.likes.toLocaleString()}</span>
                      </button>
                      <button className="flex items-center space-x-2 text-gray-600 hover:text-rose-400 transition-colors cursor-pointer">
                        <i className="ri-chat-3-line text-2xl"></i>
                      </button>
                      <button className="flex items-center space-x-2 text-gray-600 hover:text-rose-400 transition-colors cursor-pointer">
                        <i className="ri-share-line text-2xl"></i>
                      </button>
                    </div>
                    <span className="text-sm text-gray-500">{currentPost.timestamp}</span>
                  </div>
                  <p className="text-base text-gray-700 leading-relaxed">
                    <strong className="font-semibold">{account.username}</strong> {currentPost.caption}
                  </p>
                </div>
              </div>
            </div>
          </div>
        );
      })}

      {filteredAccounts.length === 0 && (
        <div className="text-center py-20">
          <div className="w-20 h-20 flex items-center justify-center bg-gray-100 rounded-full mx-auto mb-4">
            <i className="ri-image-line text-4xl text-gray-400"></i>
          </div>
          <p className="text-gray-500">해당 카테고리의 포트폴리오가 없습니다</p>
        </div>
      )}
    </div>
  );
}
